import React from 'react';

import Style from './Label.module.scss'

interface ErrorComponentProps  {
    children: React.ReactNode
}

export const ErrorComponent : React.FC<ErrorComponentProps> = (props : ErrorComponentProps)=> {
    const {children} = props;
    return <div className={ Style.labelError}>{children}</div>
}